<template>
	<div class="body-detail">
		<div class="title-box">
			<div>数据详情</div>
			<div @click="toEdit" class="flex align-center">
				<img src="../../../assets/images/user/edit@2x.png" style="width: 12px;" />
				<span class="margin-left-10">编辑数据</span>
			</div>
		</div>
		<div class="data-box" v-if="detail">

			<div class="data-item">
				<div class="header">个人信息</div>
				<div class="data-content padding-20">
					<div class="item" style="width: 33%;">
						<div class="">
							<div class="content">
								<span class="title">姓 名：</span>
								<span class="value">{{ detail.name }}</span>
							</div>
							<div class="content">
								<span class="title">性 别：</span>
								<span class="value">{{ detail.sex | get_sex }}</span>
							</div>
							<div class="content">
								<span class="title">穿衣偏好：</span>
								<span class="value">{{ detail.clothes_preference | get_mtm_preference }}</span>
							</div>
						</div>
					</div>
					<div class="item " style="width: 33%;">
						<div class="">
							<div class="content">
								<span class="title">年 龄：</span>
								<span class="value">{{ detail.birthday }}</span>
							</div>
							<div class="content">
								<span class="title">手 机：</span>
								<span class="value">{{ detail.mobile }}</span>
							</div>
							<div class="content">
								<span class="title">参考体型：</span>
								<span class="value">{{ detail.somatotype }}</span>
							</div>
						</div>
					</div>
					<div class="item" style="width: 33%;">
						<div class="">
							<div class="content">
								<span class="title">身 高：</span>
								<span class="value">{{ detail.height }}</span>
							</div>
							<div class="content">
								<span class="title">体 重：</span>
								<span class="value">{{ detail.weight }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="data-item">
				<div class="header">量体信息</div>
				<div class="body-content padding-20">
					<div class="content" style="width: 16.6%;float: left;" v-for="(item, index) in figureData" :key="index">
						<span class="title">{{ item.field_name_cn }}：</span>
						<span class="value">{{ getFigureValue(item.field_key) }}</span>
					</div>
					<div class="clear"></div>

				</div>
			</div>

			<div class="data-item">
				<div class="header">体态特征</div>
				<div class="body-content padding-20">
					<div class="content" style="width: 33%;float: left;" v-for="(item, index) in bodyData" :key="index">
						<span class="title">{{ item.field_name_cn }}：</span>
						<span class="value">{{ getBodyValue(item.field_key) }}</span>
					</div>
					<div class="clear"></div>

				</div>
			</div>


		</div>
	</div>

</template>

<script>
	import axios from 'axios'
	import {
		getFigure,
		getBodyMeta,
		getFigureMeta
	} from "@/api"
	export default {
		name: 'FBDetail',
		components: {

		},
		data() {
			return {
				detail: null,
				bodyData: [],
				figureData: [],
				id:0
			};
		},
		created() {
			this.id = this.$route.query.id
			this.get()
		},

		methods: {
			getBodyValue(key) {
				return this.detail.figure_body.body_feature[key]
			},
			getFigureValue(key) {
				if(this.detail.measure_type  == 2) {
					return this.detail.figure_body.finish_size[key]
				}
				return this.detail.figure_body.net_size[key]
			},
			async get() {
				axios.all([
					getFigure({
						id: this.id
					}),
					getBodyMeta(),
					getFigureMeta()
				]).then(axios.spread((response1, response2, response3) => {
					this.detail = response1.data

					this.bodyData = response2.data
					this.figureData = response3.data
				}))
			},

			toEdit() {
				this.$router.push({
					name: 'FigureBodyForm',
					query: { id: this.id}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.body-detail {
		width: 950px;
		height: 691px;
		background: #FFFFFF;
		border: 1px solid #EEEEEE;
		padding: 15px 20px;

		.title-box {
			color: #0F114A;
			font-size: 17px;
			font-weight: bold;
			display: flex;
			align-items: center;
			justify-content: space-between;
			cursor: pointer;
		}

		.data-box {

			.data-item {
				border: 1px solid #EEEEEE;
				margin-top: 10px;

				.header {
					height: 40px;
					line-height: 40px;
					background: #F5F5F5;
					border: 1px solid #EEEEEE;
					padding-left: 20px;
				}

				.data-content {
					display: flex;
					justify-content: space-between;
					.item {
						display: flex;
						.content:last-child {
							margin-bottom: 0px;
						}
					}
				}
			}
		}
		.content {
			margin-bottom: 10px;
			display: flex;

			.title {
				font-size: 13px;
				font-weight: bold;
				color: #333333;
			}

			.value {
				margin-left: 10px;
				font-size: 13px;
				color: #666666;
				max-width: 204px;
			}
		}
	}
	.margin-left-10{
		margin-left: 10px;
	}
</style>
